// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-body[data-v-22c684b5] {
  height: calc(var(--vh) * 100 - 60px);
  overflow-y: auto;
  background-color: var(--bg-color) !important;
}
.section-body .msg[data-v-22c684b5] {
  padding: 10px 20px;
  margin-bottom: 20px;
  background: var(--bg-color);
  box-shadow: 0 3px 3px rgba(107, 103, 103, 0.08);
}
.section-body .msg li[data-v-22c684b5] {
  padding-bottom: 0px;
}
.section-body .info-msg[data-v-22c684b5] {
  padding: 0px 20px;
  background: var(--bg-color);
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.08);
}
.section-body .info-msg .info-msg-item[data-v-22c684b5] {
  border-bottom: 1px solid var(--list-item-bordercolor);
  height: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.section-body .info-msg .info-msg-item[data-v-22c684b5]:last-child {
  border-bottom: 1px solid var(--list-item-bordercolor);
}
.section-body .info-msg .info-msg-item .status[data-v-22c684b5] {
  font-size: 14px;
}
.section-body .info-msg .info-msg-item .status i[data-v-22c684b5] {
  margin-right: 10px;
}
.section-body .info-msg .info-msg-item .status .blueFont[data-v-22c684b5] {
  color: var(--special-blue-color2);
}
.section-body .info-msg .info-msg-item .status .greyFont[data-v-22c684b5] {
  color: var(--placeholder-color);
}
.section-body .info-msg .info-msg-item .date-time[data-v-22c684b5] {
  font-size: 12px;
}
.section-body .info-msg .info-msg-item .date-time .date[data-v-22c684b5] {
  color: var(--chat-text-color);
  margin-right: 10px;
}
.section-body .info-msg-group .info-msg-group-item[data-v-22c684b5] {
  margin-bottom: 20px;
  padding: 0px 20px;
  background: var(--bg-color);
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.08);
}
.section-body .info-msg-group .info-msg-group-item .info-msg-item[data-v-22c684b5] {
  border-bottom: 1px solid var(--list-item-bordercolor);
  height: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--base-blue-color);
}
.section-body .info-msg-group .info-msg-group-item .info-msg-item[data-v-22c684b5]:last-child {
  border-bottom: 1px solid var(--list-item-bordercolor);
}
.section-body .info-msg-group .info-msg-group-item .info-msg-item .status[data-v-22c684b5] {
  font-size: 14px;
}
.section-body .info-msg-group .info-msg-group-item .info-msg-item .status i[data-v-22c684b5] {
  margin-right: 10px;
}
.section-body .info-msg-group .info-msg-group-item .info-msg-item .status .blueFont[data-v-22c684b5] {
  color: var(--special-blue-color2);
}
.section-body .info-msg-group .info-msg-group-item .info-msg-item .status .greyFont[data-v-22c684b5] {
  color: var(--placeholder-color);
}
.section-body .info-msg-group .info-msg-group-item .info-msg-item .date-time[data-v-22c684b5] {
  font-size: 12px;
}
.section-body .info-msg-group .info-msg-group-item .info-msg-item .date-time .date[data-v-22c684b5] {
  color: var(--chat-text-color);
  margin-right: 10px;
}
.section-body .info-msg-users[data-v-22c684b5] {
  border-bottom: 1px solid var(--list-item-bordercolor);
}
.section-body .info-msg-users[data-v-22c684b5]:last-child {
  border-bottom: 1px solid var(--list-item-bordercolor);
}
.section-body .info-msg-users[data-v-22c684b5]:hover {
  background: var(--asc-status-hover);
}
.section-body .info-msg-users .user[data-v-22c684b5] {
  display: flex;
  align-items: center;
  padding: 10px 0px;
  cursor: pointer;
}
.section-body .info-msg-users .user .icon-block[data-v-22c684b5] {
  margin-right: 10px;
}
.section-body .info-msg-users .user .user-info .time[data-v-22c684b5] {
  font-size: 12px;
  color: var(--chat-text-color);
}
.section-body .info-msg-users .details[data-v-22c684b5] {
  padding: 10px 0px 10px 20px;
  font-size: 12px;
  color: var(--chat-text-color);
}
.section-body .info-msg-users .details div .name[data-v-22c684b5] {
  display: inline-block;
  width: 80px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/info/DetailsMsg.vue"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,qDAAqD;AACvD;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,WAAW;AACb","sourcesContent":[".section-body[data-v-22c684b5] {\n  height: calc(var(--vh) * 100 - 60px);\n  overflow-y: auto;\n  background-color: var(--bg-color) !important;\n}\n.section-body .msg[data-v-22c684b5] {\n  padding: 10px 20px;\n  margin-bottom: 20px;\n  background: var(--bg-color);\n  box-shadow: 0 3px 3px rgba(107, 103, 103, 0.08);\n}\n.section-body .msg li[data-v-22c684b5] {\n  padding-bottom: 0px;\n}\n.section-body .info-msg[data-v-22c684b5] {\n  padding: 0px 20px;\n  background: var(--bg-color);\n  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.08);\n}\n.section-body .info-msg .info-msg-item[data-v-22c684b5] {\n  border-bottom: 1px solid var(--list-item-bordercolor);\n  height: 46px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.section-body .info-msg .info-msg-item[data-v-22c684b5]:last-child {\n  border-bottom: 1px solid var(--list-item-bordercolor);\n}\n.section-body .info-msg .info-msg-item .status[data-v-22c684b5] {\n  font-size: 14px;\n}\n.section-body .info-msg .info-msg-item .status i[data-v-22c684b5] {\n  margin-right: 10px;\n}\n.section-body .info-msg .info-msg-item .status .blueFont[data-v-22c684b5] {\n  color: var(--special-blue-color2);\n}\n.section-body .info-msg .info-msg-item .status .greyFont[data-v-22c684b5] {\n  color: var(--placeholder-color);\n}\n.section-body .info-msg .info-msg-item .date-time[data-v-22c684b5] {\n  font-size: 12px;\n}\n.section-body .info-msg .info-msg-item .date-time .date[data-v-22c684b5] {\n  color: var(--chat-text-color);\n  margin-right: 10px;\n}\n.section-body .info-msg-group .info-msg-group-item[data-v-22c684b5] {\n  margin-bottom: 20px;\n  padding: 0px 20px;\n  background: var(--bg-color);\n  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.08);\n}\n.section-body .info-msg-group .info-msg-group-item .info-msg-item[data-v-22c684b5] {\n  border-bottom: 1px solid var(--list-item-bordercolor);\n  height: 46px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: var(--base-blue-color);\n}\n.section-body .info-msg-group .info-msg-group-item .info-msg-item[data-v-22c684b5]:last-child {\n  border-bottom: 1px solid var(--list-item-bordercolor);\n}\n.section-body .info-msg-group .info-msg-group-item .info-msg-item .status[data-v-22c684b5] {\n  font-size: 14px;\n}\n.section-body .info-msg-group .info-msg-group-item .info-msg-item .status i[data-v-22c684b5] {\n  margin-right: 10px;\n}\n.section-body .info-msg-group .info-msg-group-item .info-msg-item .status .blueFont[data-v-22c684b5] {\n  color: var(--special-blue-color2);\n}\n.section-body .info-msg-group .info-msg-group-item .info-msg-item .status .greyFont[data-v-22c684b5] {\n  color: var(--placeholder-color);\n}\n.section-body .info-msg-group .info-msg-group-item .info-msg-item .date-time[data-v-22c684b5] {\n  font-size: 12px;\n}\n.section-body .info-msg-group .info-msg-group-item .info-msg-item .date-time .date[data-v-22c684b5] {\n  color: var(--chat-text-color);\n  margin-right: 10px;\n}\n.section-body .info-msg-users[data-v-22c684b5] {\n  border-bottom: 1px solid var(--list-item-bordercolor);\n}\n.section-body .info-msg-users[data-v-22c684b5]:last-child {\n  border-bottom: 1px solid var(--list-item-bordercolor);\n}\n.section-body .info-msg-users[data-v-22c684b5]:hover {\n  background: var(--asc-status-hover);\n}\n.section-body .info-msg-users .user[data-v-22c684b5] {\n  display: flex;\n  align-items: center;\n  padding: 10px 0px;\n  cursor: pointer;\n}\n.section-body .info-msg-users .user .icon-block[data-v-22c684b5] {\n  margin-right: 10px;\n}\n.section-body .info-msg-users .user .user-info .time[data-v-22c684b5] {\n  font-size: 12px;\n  color: var(--chat-text-color);\n}\n.section-body .info-msg-users .details[data-v-22c684b5] {\n  padding: 10px 0px 10px 20px;\n  font-size: 12px;\n  color: var(--chat-text-color);\n}\n.section-body .info-msg-users .details div .name[data-v-22c684b5] {\n  display: inline-block;\n  width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
